import { ApplicationConfig, enableProdMode, inject, mergeApplicationConfig, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideDatadogErrorHandler, provideDatadogRouter } from '@datadog/browser-rum-angular';
import 'hammerjs';
import 'zone.js';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { DatadogRumService } from './app/shared/services/datadog-rum.service';
import { captureRedirectIfProtected, detectPunchOut, preMarkPunchOut } from './app/utils/auth-utils';
import { environment } from './environments/environment';

// Kept out of the shared appConfig (app.config.ts) because app.config.server.ts
// merges that same config into the SSR bootstrap, and these are browser-only:
// registering provideDatadogRouter()/provideDatadogErrorHandler() server-side
// would install Datadog's ErrorHandler and router hooks in the Node.js
// renderer for a client-only SDK that never actually initializes there.
const browserConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => inject(DatadogRumService).init()),
    // Router is registered via RouterModule.forRoot() inside AppModule;
    // provideDatadogRouter() works with either NgModule or standalone router setup.
    provideDatadogRouter(),
    provideDatadogErrorHandler(),
  ],
};

if (environment.production) {
  enableProdMode();
}

// Step 1: Store the punchout sid early before Angular bootstraps
preMarkPunchOut();

// Step 2: Detect if this tab is violating punchout session rules
detectPunchOut();

// Step 3: Track intended deep link (if user is not logged in)
captureRedirectIfProtected();

const loginNotificationStorageKey = 'loginNotificationUrl';
const loginNotificationUrl = localStorage.getItem(loginNotificationStorageKey);

if (loginNotificationUrl) {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = loginNotificationUrl;
} else {
  // Bootstrap Angular (guest /my-account → login gate runs in provideAppInitializer when the flag is on)
  bootstrapApplication(AppComponent, mergeApplicationConfig(appConfig, browserConfig))
    .catch((err) => console.error(err));
}
